import { rand, randNumber, randSentence } from '@ngneat/falso';
import {
  initVersionedSchema,
  MixedSchema,
  RawInlineNodes,
  toTextContent,
} from '@principle-theorem/editor';
import {
  IAppointment,
  IAppointmentDocument,
  IInteraction,
  ILab,
  ILabJob,
  IPatient,
  IStaffer,
  LAB_JOB_STATUSES,
  LabJobStatus,
} from '@principle-theorem/principle-core/interfaces';
import {
  BaseFirestoreMock,
  MockGenerator,
  MockTimestamp,
  Properties,
} from '@principle-theorem/shared';
import { MockDocRef, MockNamedDocument } from '@principle-theorem/testing';
import { InteractionMock } from '../interaction/interaction.mock';
import { MockLabJobType } from '../lab/lab.mock';

export class LabJobMock
  extends BaseFirestoreMock<Properties<ILabJob>>
  implements Properties<ILabJob>
{
  title: RawInlineNodes = [toTextContent(randSentence())];
  description: MixedSchema = initVersionedSchema(randSentence());
  dueDate = MockTimestamp();
  completedDate = MockTimestamp();
  sentAt = MockTimestamp();
  receivedAt = MockTimestamp();
  issuedAt = MockTimestamp();
  interactions: IInteraction[] = [MockGenerator.generate(InteractionMock)];
  lab = MockNamedDocument<ILab>();
  practitioner = MockNamedDocument<IStaffer>();
  status = rand(LAB_JOB_STATUSES);
  statusHistory = [
    {
      status: LabJobStatus.Sending,
      updatedAt: MockTimestamp(),
    },
    {
      status: LabJobStatus.Sent,
      updatedAt: MockTimestamp(),
    },
  ];
  patient = MockNamedDocument<IPatient>();
  appointment = MockAppointmentDocument();
  type = MockLabJobType();
  cost = randNumber({
    min: 200,
    max: 800,
  });
}

function MockAppointmentDocument(): IAppointmentDocument {
  return {
    treatmentPlanName: randSentence(),
    ref: MockDocRef<IAppointment>(),
  };
}
